import { MapPin } from "lucide-react";
import { PROJECTS } from "@/lib/content";

export const Projects = () => (
  <section id="progetti" className="bg-slate-50 py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <span className="eyebrow">Progetti Realizzati</span>
      <h2 className="section-title mt-5 max-w-2xl">Impianti che lavorano ogni giorno.</h2>
      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {PROJECTS.map((p, i) => (
          <figure
            key={p.id}
            data-testid={`project-card-${p.id}`}
            className={`group relative overflow-hidden rounded-3xl ${i === 0 ? "lg:row-span-2" : ""}`}
          >
            <img src={p.img} alt={p.title} loading="lazy" className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${i === 0 ? "aspect-[4/3] lg:aspect-auto lg:h-full" : "aspect-[4/3]"}`} />
            <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/75 to-transparent p-6 text-white">
              <span className="rounded-full bg-white/20 px-2.5 py-1 text-xs font-medium backdrop-blur">{p.category}</span>
              <p className="mt-3 font-display text-lg font-semibold">{p.title}</p>
              <p className="mt-1 flex items-center gap-1 text-sm text-white/75"><MapPin className="h-3.5 w-3.5" /> {p.place}</p>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);
